import { PopupModal } from 'components/modals/ModalBox'
import useButtonLoader from 'hooks/useButtonLoader';
import React from 'react'
import { offerChangeStatus } from 'services/offer';
import { toastMessage } from 'utils/toastMessage';

const ChangeStatusOffer = ({ show, close, selectedData, offerList = [], setOfferList = () => { } }) => {
    const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
    const status = selectedData.status === "INACTIVE" ? "Unblock" : "Block"
    // ---------------change-status-API---------------
    const changeStatusHandler = async () => {
        try {
            const reqData = {
                status: selectedData.status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
            };
            setButtonLoader(true);
            const res = await offerChangeStatus(selectedData?._id, reqData);
            const { code, data, message } = res?.data;
            if (code === 200) {
                setOfferList(
                    offerList?.map((item) =>
                        item._id === selectedData._id
                            ? { ...item, status: reqData.status }
                            : item
                    )
                );
                close();
                toastMessage(message, "success", "changeUserStatus");
            }
        } catch (e) {
            console.log("error:", e.error);
        } finally {
            setButtonLoader(false);
        }
    };
    return (
        <PopupModal
            show={show}
            handleClose={close}
            content={`Do You Really Want To ${status} This Offer?`}
            title="Change Offer Status"
            buttonLoader={buttonLoader}
            action={changeStatusHandler}
        />
    )
}

export default ChangeStatusOffer